import { FormBox } from 'components/form';
import useWindowsDimension from 'functions/useWindowsDimension';
import { rq, rqPost } from 'http/apiRoutes';
import { useGet, usePost, usePut } from 'http/useApi';
import { memo, useEffect, useReducer, useState } from 'react';
import { useParams } from 'react-router';
// @ts-ignore
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import {
  Avatar,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { ProductCardPackage } from 'components/ui/ProductCardPackage';

import BallotRoundedIcon from '@mui/icons-material/BallotRounded';
import ownerAtom from 'data/atoms/ownerAtom';
import { GenerateGuid } from 'functions/GuidChecks';
import { IDepartmentViewModel } from 'Interfaces/ICompaniesConfig';
import {
  EnumObjectType,
  allObjectList,
  objectArray,
} from 'Interfaces/IGlobalTypeConfig';
import { useAtom } from 'jotai';
import _ from 'lodash';
import { IBillingProductViewModel } from 'pages/Billing/BillingConfig';
import { useTranslation } from 'react-i18next';
import {
  IPackageAddViewModel,
  IPackageEditViewModel,
  IPackageViewModel,
  IProductPackageProductAddViewModel,
  IProductPackageProductViewModel,
} from '../../Interfaces/IPackageConfig';
import { ObjectDrawer } from './ObjectDrawer';

const variables = {
  PHOTO_URL: process.env.PUBLIC_URL + '/img/',
};
let teller = -1;
const img = [
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
  {
    index: teller++,
    imageUrl: `${variables.PHOTO_URL}BG ${teller++}.png`,
  },
];

const initialState: IPackageEditViewModel = {
  id: '',
  name: '',
  description: '',
  isDefault: false,
  defaultDepartmentId: '',
  active: false,
  productPackageProducts: [] as IProductPackageProductViewModel[],
  investment: 0,
  monthly: 0,
  quarterly: 0,
  yearly: 0,
};

const reducer = (state: any, action: any) => {
  const findPaymentCycle = (cycle: any) => {
    let _paymentCycle;
    switch (cycle) {
      case 1:
        _paymentCycle = 1;
        break;
      case 3:
        _paymentCycle = 3;
        break;
      case 12:
        _paymentCycle = 12;
        break;
      default:
        _paymentCycle = 0;
    }
    return _paymentCycle;
  };
  switch (action.type) {
    case 'ADD_PRODUCT': {
      const newProduct: IBillingProductViewModel = action.payload;

      // Check if the product already exists in the package
      const existingProductIndex = state.productPackageProducts.findIndex(
        (p: IProductPackageProductViewModel) => p.product.id === newProduct.id
      );
      const paymentCycle = findPaymentCycle(newProduct.paymentCycle);
      const retailPrice = newProduct.retailPrice;
      if (existingProductIndex !== -1) {
        // Product already exists, handle accordingly (e.g., increase quantity)
        return state; // or another appropriate action
      }

      // Convert IProductViewModel to IProductPackageProductViewModel
      const newProductPackageProduct: IProductPackageProductViewModel = {
        id: GenerateGuid(), // Generate or assign an appropriate ID
        productPackageId: state.id, // Assuming this is the ID of the package
        productId: newProduct.id,
        product: newProduct,
        quantity: 1, // Starting quantity
      };

      return {
        ...state,
        productPackageProducts: [
          ...state.productPackageProducts,
          newProductPackageProduct,
        ],
        monthly:
          paymentCycle === 1 ? state.monthly + retailPrice : state.monthly,
        quarterly:
          paymentCycle === 3 ? state.quarterly + retailPrice : state.quarterly,
        yearly: paymentCycle === 12 ? state.yearly + retailPrice : state.yearly,
        investment:
          paymentCycle === 0
            ? state.investment + retailPrice
            : state.investment,
      };
    }
    case 'DELETE_PRODUCT': {
      const productIdToDelete = action.payload.id;

      // Filter out the product to delete
      const updatedProductPackageProducts = state.productPackageProducts.filter(
        (p: IProductPackageProductViewModel) =>
          p.product.id !== productIdToDelete
      );

      return {
        ...state,
        productPackageProducts: updatedProductPackageProducts,
        // Update other state properties if necessary
      };
    }
    case 'REMOVE_PRODUCT':
      return {
        ...state,
        productPackageProducts: state.productPackageProducts.filter(
          (product: IBillingProductViewModel) =>
            product.id !== action.payload.id
        ),
      };
    case 'INCREASE_PRODUCT_QUANTITY': {
      const productIndex = state.productPackageProducts.findIndex(
        (prod: IProductPackageProductViewModel) =>
          prod.product.id === action.payload
      );

      if (productIndex === -1) {
        // Product not found
        return state;
      }

      const product = state.productPackageProducts[productIndex];
      let newProductPackageProducts = [...state.productPackageProducts];

      // Increment the product quantity
      const newQuantity = product.quantity + 1;

      if (newQuantity > 0) {
        // Update the product with the new quantity
        newProductPackageProducts[productIndex] = {
          ...product,
          quantity: newQuantity,
        };
      } else {
        // Remove the product if the new quantity is 0
        newProductPackageProducts = newProductPackageProducts.filter(
          (_, index) => index !== productIndex
        );
      }

      const paymentCycle = findPaymentCycle(product.product.paymentCycle);
      const retailPrice = product.product.retailPrice;

      // Update the financial metrics accordingly
      return {
        ...state,
        productPackageProducts: newProductPackageProducts,
        monthly:
          paymentCycle === 1 ? state.monthly + retailPrice : state.monthly,
        quarterly:
          paymentCycle === 3 ? state.quarterly + retailPrice : state.quarterly,
        yearly: paymentCycle === 12 ? state.yearly + retailPrice : state.yearly,
        investment:
          paymentCycle === 0
            ? state.investment + retailPrice
            : state.investment,
      };
    }
    case 'DECREASE_PRODUCT_QUANTITY': {
      const productIndex = state.productPackageProducts.findIndex(
        (prod: IProductPackageProductViewModel) =>
          prod.product.id === action.payload
      );

      if (productIndex === -1) {
        // Product not found, return state as is.
        return state;
      }

      const product = state.productPackageProducts[productIndex];
      const newProductPackageProducts = [...state.productPackageProducts];

      if (product.quantity === 1) {
        newProductPackageProducts.splice(productIndex, 1);
      } else {
        newProductPackageProducts[productIndex] = {
          ...product,
          quantity: product.quantity - 1,
        };
      }

      const paymentCycle = findPaymentCycle(product.product.paymentCycle);
      const retailPrice = product.product.retailPrice;

      return {
        ...state,
        productPackageProducts: newProductPackageProducts,
        monthly:
          paymentCycle === 1 ? state.monthly - retailPrice : state.monthly,
        quarterly:
          paymentCycle === 3 ? state.quarterly - retailPrice : state.quarterly,
        yearly: paymentCycle === 12 ? state.yearly - retailPrice : state.yearly,
        investment:
          paymentCycle === 0
            ? state.investment - retailPrice
            : state.investment,
      };
    }
    case 'CHANGE_DEPARTMENT':
      return {
        ...state,
        defaultDepartmentId: action.defaultDepartmentId,
      };
    case 'CHANGE_NAME':
      return {
        ...state,
        name: action.name,
      };
    case 'CHANGE_DESCRIPTION':
      return {
        ...state,
        description: action.description,
      };
    case 'CHANGE_DEFAULT_PACKAGE':
      return {
        ...state,
        isDefault: action.isDefault,
      };
    case 'REPLACE_STATE':
      const packageViewModel = action.payload as IPackageViewModel; // Assuming this is of type IPackageViewModel
      let monthly = 0;
      let quarterly = 0;
      let yearly = 0;
      let investment = 0;
      packageViewModel.productPackageProducts &&
        packageViewModel.productPackageProducts.forEach(
          (productPackageProduct: IProductPackageProductViewModel) => {
            const paymentCycle = findPaymentCycle(
              productPackageProduct.product.paymentCycle
            );
            const retailPrice = productPackageProduct.product.retailPrice;
            const quantity = productPackageProduct.quantity;

            switch (paymentCycle) {
              case 1:
                monthly += retailPrice * quantity;
                break;
              case 3:
                quarterly += retailPrice * quantity;
                break;
              case 12:
                yearly += retailPrice * quantity;
                break;
              default:
                investment += retailPrice * quantity;
            }
          }
        );

      return {
        ...state,
        ...packageViewModel,
        monthly: monthly,
        quarterly: quarterly,
        yearly: yearly,
        investment: investment,
      };

    default:
      return state;
  }
};

type Props = {
  packageData: IPackageViewModel;
  isDefaultPackage: boolean;
};

const convertToPackageAddViewModel = (
  state: IPackageViewModel,
  companyId: string
): IPackageAddViewModel => {
  // Map productPackageProducts from IProductPackageProductViewModel[] to IProductPackageProductAddViewModel[]
  const productPackageProducts: IProductPackageProductAddViewModel[] =
    state.productPackageProducts.map((productPackageProduct) => ({
      productId: productPackageProduct.productId,
      productPackageId: GenerateGuid(),
      quantity: productPackageProduct.quantity,
    }));

  const _state: IPackageAddViewModel = {
    name: state.name,
    description: state.description,
    isDefault: state.isDefault,
    defaultDepartmentId: state.defaultDepartmentId,
    companyId: companyId,
    active: state.active,
    productPackageProducts: productPackageProducts,
  };

  return _state;
};

export const PackageForm = ({ packageData, isDefaultPackage }: Props) => {
  const { t } = useTranslation();

  /* INITIALIZATIONS */
  const { height } = useWindowsDimension();
  const { companyId, packageId } = useParams();
  const [isProducts, setIsProducts] = useState(true);
  const [products, setProducts] = useState<IBillingProductViewModel[]>([]);
  const [isDepartments, setIsDepartments] = useState(true);
  const [departments, setDepartments] = useState<any[]>([]);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [owner, setOwner] = useAtom(ownerAtom);
  const [objectDrawerList, setObjectDrawerList] =
    useState<objectArray[]>(allObjectList);

  let packageID =
    packageId !== undefined
      ? packageId
      : '601f90d5-6ab0-4fbc-8d0c-c1cc00000001';
  let companyID = companyId !== undefined ? companyId : owner.id;

  // api
  let _companyId = companyID ? companyID : '';
  const postProductPackage = usePost(rqPost.package(_companyId, false));
  const putProductPackage = usePut(rqPost.package(_companyId, false));
  const { data: departmentData } = useGet(
    rq.departments(_companyId, isDepartments)
  );
  // api
  const { data: productsData } = useGet(rq.products(isProducts), );
  /* FUNCTIONS */

  // handles
  const handleChangeDepartment = (e: any) => {
    dispatch({
      type: 'CHANGE_DEPARTMENT',
      defaultDepartmentId: e.target.value,
    });
    const _department = departments.find((dept) => dept.id === e.target.value);
    let name = _department.name + ' package';
    dispatch({ type: 'CHANGE_NAME', name: name });
  };
  const handleChangeName = (e: any) => {
    dispatch({ type: 'CHANGE_NAME', name: e.target.value });
  };
  const handleChangeDescription = (e: any) => {
    dispatch({ type: 'CHANGE_DESCRIPTION', description: e.target.value });
  };
  const handleDecProduct = (product: IBillingProductViewModel) => {
    dispatch({ type: 'DECREASE_PRODUCT_QUANTITY', payload: product.id });
  };

  const handleIncProduct = (product: IBillingProductViewModel) => {
    dispatch({ type: 'INCREASE_PRODUCT_QUANTITY', payload: product.id });
  };

  /* HANDLSES */
  type FormOrMouseEvent =
    | React.FormEvent<HTMLFormElement>
    | React.MouseEvent<HTMLDivElement, MouseEvent>;

  const handleChangeObjectDrawer = (
    event: FormOrMouseEvent,
    selectedObject: any,
    objectType: EnumObjectType
  ) => {
    switch (objectType) {
      case EnumObjectType.Product:
        let object = selectedObject as IBillingProductViewModel;
        dispatch({ type: 'ADD_PRODUCT', payload: object });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (productsData && productsData.products) {
      const index = objectDrawerList.findIndex(
        (item) => item.objectType === EnumObjectType.Product
      );
      const updatedArrayList = [...objectDrawerList];
      if (index !== -1) {
        // Update the objectList of the current object
        updatedArrayList[index].objectList = [
          ...updatedArrayList[index].objectList,
          ...(productsData?.products as IBillingProductViewModel[]),
        ];
        setObjectDrawerList(updatedArrayList);
        let tmp = _.cloneDeep(
          productsData.products
        ) as IBillingProductViewModel[];
        setIsProducts(false);
        setProducts(tmp);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsData]);

  useEffect(() => {
    if (departmentData && departmentData.departments) {
      let tmp = _.cloneDeep(
        departmentData.departments
      ) as IDepartmentViewModel[];
      setIsDepartments(false);
      setDepartments(tmp);
    }
  }, [departmentData]);

  // form submit
  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (packageID === 'new') {
      let newPackage = convertToPackageAddViewModel(state, companyID || '');
      // console.log('submit newPackage POST :* ', newPackage);
      postProductPackage.mutate(newPackage);
    } else {
      const _state: IPackageViewModel = {
        id: state.id,
        name: state.name,
        description: state.description,
        isDefault: state.isDefault,
        defaultDepartmentId: state.defaultDepartmentId,
        active: state.active,
        productPackageProducts: state.productPackageProducts,
      };

      // console.log('submit _state PUT :* ', _state);
      putProductPackage.mutate(_state);
    }
  };
  useEffect(() => {
    if (packageData) {
      let data = packageData as IPackageViewModel;
      dispatch({ type: 'REPLACE_STATE', payload: data });
    }
  }, [packageID, packageData]);

  const handleDefaultPackageChange = () => {
    dispatch({
      type: 'CHANGE_DEFAULT_PACKAGE',
      isDefault: !state.isDefault, // Toggle the value directly here
    });
  };

  const ActiveJSX = memo(() => {
    return (
      <>
        {isDefaultPackage === false && (
          <Grid>
            {state.isDefault ? t('switch.yes') : t('switch.no')}
            <Switch
              color={state.isDefault ? 'secondary' : 'primary'}
              sx={{
                mt: 0,
                mr: 0,
                '& .MuiSwitch-thumb': {
                  backgroundColor: state.isDefault
                    ? 'secondary.light'
                    : 'primary.text',
                },
                '& .MuiSwitch-track': {
                  backgroundColor: state.isDefault
                    ? 'rgba(0, 0, 0, 0.7)'
                    : 'rgba(0, 0, 255, 0.3)',
                },
              }}
              checked={state.isDefault}
              onChange={handleDefaultPackageChange}
              name='isDefaultPackage'
            />
          </Grid>
        )}
      </>
    );
  });

  return (
    <>
      <Grid item xs={12} sx={{ p: 2, height: 64 }}>
        <FormBox
          Icon={BallotRoundedIcon}
          title={t('company.packages.detailsHeader')}
          FormJSX={ActiveJSX}
        />
      </Grid>

      <Grid container direction={'row'} sx={{}}>
        <Grid item xs={4} sx={{ p: 2, pr: 1 }}>
          {isDefaultPackage === false && (
            <FormControl fullWidth sx={{ pb: 2 }}>
              <InputLabel id='selected-department-label'>
                {t('company.packages.selectDepartment')}
              </InputLabel>
              <Select
                variant='standard'
                labelId='selected-department-label'
                id='selected-department'
                value={state.defaultDepartmentId}
                //defaultValue={state.defaultDepartmentId}
                label={t('company.packages.selectDepartment')}
                onChange={(e: any) => handleChangeDepartment(e)}
              >
                {!!departments &&
                  departments.map((dep: any) => (
                    <MenuItem value={dep.id} key={dep.id}>
                      {dep.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
          {state.id ? (
            <Avatar
              variant='rounded'
              alt={state.name}
              // src={img[selectedPackage.imageNr].imageUrl}
              sx={{
                mx: 'auto',
                width: '100%',
                height: 128,
                borderRadius: 2,
                pt: 1,
              }}
            />
          ) : (
            <Avatar
              variant='rounded'
              alt={'unnamed'}
              src={img[0].imageUrl}
              sx={{
                mx: 'auto',
                width: '100%',
                height: 128,
                borderRadius: 2,
                pt: 1,
              }}
            />
          )}
        </Grid>

        <Grid item xs={4} sx={{ p: 2, pl: 1 }}>
          {isDefaultPackage === false && (
            <FormControl fullWidth sx={{ pb: 2 }}>
              <TextField
                id='name'
                label={t('company.packages.name')}
                variant='standard'
                value={state.name}
                onChange={(e: any) => handleChangeName(e)}
              />
            </FormControl>
          )}
          <FormControl fullWidth sx={{}}>
            <TextField
              id='description'
              label={t('company.packages.description')}
              variant='standard'
              multiline
              maxRows={3}
              rows={3.5}
              value={state.description}
              onChange={(e: any) => handleChangeDescription(e)}
            />
          </FormControl>
        </Grid>

        <Grid
          item
          xs={4}
          sx={{
            pr: 1,
          }}
        >
          <Paper
            variant='elevation3'
            sx={{ backgroundColor: 'primary.back', p: 1, height: 200 }}
          >
            <Typography
              sx={{
                width: '100%',
                textAlign: 'Left',
                letterSpacing: 2,
                fontSize: 16,
                fontWeight: 'bold',
              }}
            >
              {t('company.packages.investment')}
            </Typography>
            <Stack direction={'row'} sx={{ width: '100%' }}>
              <Typography sx={{ textAlign: 'end', width: '50%' }}>
                {t('company.packages.investmentTotal')}
              </Typography>
              <Typography
                sx={{
                  width: '50%',
                  textAlign: 'end',
                  color: 'secondary.text',
                  fontWeight: 'bold',
                }}
              >
                {state.investment.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Stack>
            <Typography
              sx={{
                width: '100%',
                pt: 2,
                textAlign: 'Left',
                letterSpacing: 2,
                fontSize: 16,
                fontWeight: 'bold',
              }}
            >
              {t('company.packages.agreement')}
            </Typography>
            <Stack direction={'row'} sx={{ width: '100%' }}>
              <Typography sx={{ textAlign: 'end', width: '50%' }}>
                {t('company.packages.monthly')}
              </Typography>
              <Typography
                sx={{
                  width: '50%',
                  textAlign: 'end',
                  color: 'secondary.text',
                  fontWeight: 'bold',
                }}
              >
                {state.monthly.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Stack>
            <Stack direction={'row'} sx={{ width: '100%' }}>
              <Typography sx={{ textAlign: 'end', width: '50%' }}>
                {t('company.packages.quarterly')}
              </Typography>
              <Typography
                sx={{
                  width: '50%',
                  textAlign: 'end',
                  color: 'secondary.text',
                  fontWeight: 'bold',
                }}
              >
                {state.quarterly.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Stack>
            <Stack direction={'row'} sx={{ width: '100%' }}>
              <Typography sx={{ textAlign: 'end', width: '50%' }}>
                {t('company.packages.yearly')}
              </Typography>
              <Typography
                sx={{
                  width: '50%',
                  textAlign: 'end',
                  color: 'secondary.text',
                  fontWeight: 'bold',
                }}
              >
                {state.yearly.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </Stack>
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            pl: 1,
            pr: 2,
            pb: 1,
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <ObjectDrawer
            buttonContext={t('company.packages.addPackageProduct')}
            buttonIcon={<ChangeCircleIcon sx={{ fontSize: 40 }} />}
            objectList={!!objectDrawerList ? objectDrawerList : []}
            objectType={[EnumObjectType.Product]}
            handleChange={handleChangeObjectDrawer}
            buttonHeight={40}
            buttonWidth={60}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <List
            sx={{
              p: 2,
              width: '100%',
              height:
                isDefaultPackage === false
                  ? Math.ceil(height - 566)
                  : Math.ceil(height - 460),
              backgroundColor: 'primary.back',
              overflow: 'auto',
            }}
          >
            {state.productPackageProducts.length > 0 &&
              state.productPackageProducts.map((prod: any) => {
                return !!prod ? (
                  <ListItem sx={{ mb: 1, p: 0 }} button key={prod.id}>
                    <ProductCardPackage
                      key={prod.id}
                      companyProduct={prod}
                      handleIncProduct={handleIncProduct}
                      handleDecProduct={handleDecProduct}
                    />
                  </ListItem>
                ) : null;
              })}
          </List>
        </Grid>
      </Grid>
      <Paper
        variant='elevation3'
        sx={{
          p: 0,
          height: 64,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <Button
            variant='contained'
            onClick={(e: any) => handleSubmit(e)}
            disabled={
              postProductPackage.isLoading ||
              state.productPackageProducts.length === 0
            }
          >
            {packageID === 'new'
              ? 'Create Product Package'
              : 'Update Product Package'}
          </Button>
        </Box>
      </Paper>
    </>
  );
};
